<div *ngIf="options && mainForm !== undefined" class="radioBlock" [ngClass]="layoutModifier">
  <div class="radioBlock-group" [ngClass]="{
    'radioBlock-group_required': state === 'required',
    'radioBlock-group_error': state === 'error',
    'radioBlock-group_updated': state === 'updated' || highlight,
    'radioBlock-group_new': state === 'new'
  }" [formGroup]="mainForm">
    <div class="radioBlock-item" [tabIndex]="0" *ngFor="let o of options; let i=index;" (click)="onClick($event, o)">
      <input type="radio" [formControlName]="controlName" [id]="controlName + '_' + i"
        [value]="valueKey ? o[valueKey] : o"
        [attr.disabled]="mainForm.status === 'DISABLED' || (!allowDisabledSelection && disabledKey && o[disabledKey]) ? '' : null"
        class="radioBlock-input"
        [ngClass]="{ 'radioBlock-input_disabled': allowDisabledSelection && disabledKey && o[disabledKey] }">
      <label [for]="controlName + '_' + i" class="radioBlock-label"
        [ngClass]="{
          'radioBlock-label_hasIcon': imageKey && o[imageKey],
          'radioBlock-label_default': markDefaultKey && o[markDefaultKey] === 'BY_DEFAULT'
        }">
        <div *ngIf="o[imageKey]" class="radioBlock-icon" svgImage [themeImage]="o[imageKey]"></div>
        <app-tooltip *ngIf="mouseoverTexts && mouseoverTexts[o.id]" class="radioBlock-tooltip" [minWidth]="'360px'"
          [hasTooltip]="true" [text]="mouseoverTexts[o.id]">
          <i svgIcon [icon]="'info'" [iconSize]="svgIconSizeMod.EXTRA_SMALL"></i>
        </app-tooltip>
        <ng-container *ngIf="labelKey && o[labelKey]">
          {{ o[labelKey] | translate }}
        </ng-container>
      </label>
    </div>
  </div>
</div>
